import {
  fetchChangesHistoryRoutine,
  fetchProductsRoutine,
  fetchShiftHistoryRoutine,
  fetchSingleProductRoutine
} from 'modules/products/ducks/actions'

const defaultState = {
  list: [],
  currentProduct: {},
  pagination: null,
  shiftHistoryList: [],
  changesHistoryList: [],
  shiftHistoryListPagination: null,
  changesHistoryListPagination: null,
  isLoading: false,
  isLoadingChangesHistory: false,
  isLoadingShiftHistory: false,
  isLoadingCurrentProduct: false
}

const productsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case fetchProductsRoutine.TRIGGER:
      return {
        ...state,
        isLoading: true
      }
    case fetchProductsRoutine.FAILURE:
      return {
        ...state,
        isLoading: false
      }
    case fetchProductsRoutine.SUCCESS:
      return {
        ...state,
        list: action.payload.data,
        pagination: {
          itemsCount: action.payload.meta.total,
          totalPages: action.payload.meta.lastPage,
          perPage: action.payload.meta.perPage,
          currentPage: action.payload.meta.currentPage
        },
        isLoading: false
      }
    case fetchSingleProductRoutine.TRIGGER:
      return {
        ...state,
        isLoadingCurrentProduct: true
      }
    case fetchSingleProductRoutine.FAILURE:
      return {
        ...state,
        isLoadingCurrentProduct: false
      }
    case fetchSingleProductRoutine.SUCCESS:
      return {
        ...state,
        currentProduct: action.payload,
        isLoadingCurrentProduct: false
      }
    case fetchShiftHistoryRoutine.TRIGGER:
      return {
        ...state,
        isLoadingShiftHistory: true
      }
    case fetchShiftHistoryRoutine.FAILURE:
      return {
        ...state,
        isLoadingShiftHistory: false
      }
    case fetchShiftHistoryRoutine.SUCCESS:
      return {
        ...state,
        shiftHistoryList: action.payload.data,
        shiftHistoryListPagination: {
          itemsCount: action.payload.meta.total,
          totalPages: action.payload.meta.lastPage,
          perPage: action.payload.meta.perPage,
          currentPage: action.payload.meta.currentPage
        },
        isLoadingShiftHistory: false
      }
    case fetchChangesHistoryRoutine.TRIGGER:
      return {
        ...state,
        isLoadingChangesHistory: true
      }
    case fetchChangesHistoryRoutine.FAILURE:
      return {
        ...state,
        isLoadingChangesHistory: false
      }
    case fetchChangesHistoryRoutine.SUCCESS:
      return {
        ...state,
        changesHistoryList: action.payload.data,
        changesHistoryListPagination: {
          itemsCount: action.payload.meta.total,
          totalPages: action.payload.meta.lastPage,
          perPage: action.payload.meta.perPage,
          currentPage: action.payload.meta.currentPage
        },
        isLoadingChangesHistory: false
      }
    default:
      return state
  }
}

export default productsReducer
